import { UnorderedListOutlined, NotificationOutlined, RiseOutlined, FileOutlined, BankOutlined, ProfileOutlined, TeamOutlined, UserOutlined, FileDoneOutlined, VideoCameraOutlined, AuditOutlined, HighlightOutlined } from '@ant-design/icons';
import { PERMISSIONS } from '../components/Permissions/utils/permissions';
export const publicRoutes = [
  {
    path: "/login",
    component: "./pages/Login/Login.react"
  },
  {
    path: "/logout",
    component: "./pages/Login/Login.react"
  },
  {
    path: "/user/confirm/:confirmationToken",
    component: "./pages/Signup/Signup.react"
  },
  {
    path: "/change-password",
    component: "./pages/Login/ChangePassword.react"
  },
  {
    path: "/resource/:resourceType/:resourceId/token/:token/view",
    component: "./components/Share/ShareViewer"
  }
];

export const privateRoutes = [
  {
    name: 'GESTIONE',
    path: '/management',
    component: './pages/SystemsManager/SystemsManager',
    permission: PERMISSIONS.SYSTEM_MENU,
    routes: [
      {
        name: <><BankOutlined /> Impianti</>,
        path: '/management/systems',
        component: './pages/SystemsManager/SystemsManager',
        permission: PERMISSIONS.SYSTEM_MENU,
        disabled: false
      },
      {
        name: <><TeamOutlined /> Fornitori</>,
        path: '/management/teamManagement',
        component: './pages/Suppliers/SuppliersManager',
        permission: PERMISSIONS.TEAM_MENU,
      },
      {
        name: <><FileDoneOutlined /> Permessi</>,
        path: '/management/licenses',
        component: './pages/Licenses/LicensesManager',
        permission: PERMISSIONS.LICENSE_MENU,
      },
    ]
  },

  {
    path: "/select-tenant",
    component: "./pages/Login/SelectTenant.react",
    permission: PERMISSIONS.USER_READ,
  },

  {
    path: '/',
    component: './pages/SystemsManager/SystemsManager',
    permission: PERMISSIONS.SYSTEM_MENU,
  },

  // Systems
  {
    path: '/management/systems/map',
    component: './pages/SystemsManager/SystemsManager',
    permission: PERMISSIONS.SYSTEM_MENU,
  },
  {
    path: '/management/systems',
    component: './pages/SystemsManager/SystemsManager',
    permission: PERMISSIONS.SYSTEM_MENU,
  },
  {
    path: '/management/systems/new',
    component: './pages/SystemsManager/SystemFormPage',
    permission: PERMISSIONS.SYSTEM_MENU,
  },
  {
    path: '/management/systems/:id',
    component: './pages/SystemsManager/Systems.Detail',
    permission: PERMISSIONS.SYSTEM_READ,
  },

  // Teams
  {
    path: '/management/teamManagement',
    component: './pages/Suppliers/SuppliersManager',
    permission: PERMISSIONS.TEAM_MENU,
  },

  // Licenses
  {
    path: '/management/licenses',
    component: './pages/Licenses/LicensesManager',
    permission: PERMISSIONS.LICENSE_MENU,
  },
  {
    path: '/management/licenses/:id',
    component: './pages/Licenses/LicenseDetail',
    permission: PERMISSIONS.LICENSE_READ,
  },

  // SALES
  {
    name: 'VENDITE',
    path: '/sales',
    component: './pages/Negotiations/NegotiationsManager',
    permission: PERMISSIONS.NEGOTIATION_MENU,
    routes: [
      { name: <><UserOutlined /> Inserzionisti</>, path: '/sales/advertisers', permission: PERMISSIONS.ADVERTISER_MENU, disabled: false },
      { name: <><FileOutlined /> Trattative </>, path: '/sales/negotiations', permission: PERMISSIONS.NEGOTIATION_MENU, disabled: false },
      { name: <>< ProfileOutlined /> Ordini</>, path: '/sales/orders', permission: PERMISSIONS.ORDER_MENU, disabled: false },
      { name: <><RiseOutlined /> Dashboard Funnel</>, path: '/sales/dashboardAnalytics', permission: PERMISSIONS.ANALYTICS_MENU, disabled: false },
    ]
  },

  // Advertisers
  {
    path: '/sales/advertisers',
    component: './pages/Advertisers/AdvertiserPage',
    permission: PERMISSIONS.ADVERTISER_MENU,
  },
  {
    path: '/sales/advertisers/:id',
    component: './pages/Advertisers/AdvertiserDetailPage',
    permission: PERMISSIONS.ADVERTISER_READ,
  },

  // Negotiations
  {
    path: '/sales/negotiations',
    component: './pages/Negotiations/NegotiationsManager',
    permission: PERMISSIONS.NEGOTIATION_MENU,
  },
  {
    path: '/sales/negotiations/:id',
    component: './pages/Negotiations/NegotiationsDetail',
    permission: PERMISSIONS.NEGOTIATION_READ,
  },

  // Quotes
  {
    path: "/sales/quote/:id/view",
    component: "./pages/Quotes/QuoteDetail.jsx",
    permission: PERMISSIONS.QUOTE_READ,
  },
  {
    path: "/sales/quote/:id/edit",
    component: "./pages/Quotes/QuoteDetail.jsx",
    permission: PERMISSIONS.QUOTE_READ,
  },

  // Orders
  {
    path: "/sales/orders",
    component: "./pages/Orders/OrdersManager.jsx",
    permission: PERMISSIONS.ORDER_MENU,
  },
  {
    path: "/sales/orders/:id",
    component: "./pages/Orders/OrderDetail.jsx",
    permission: PERMISSIONS.ORDER_READ,
  },

  {
    path: '/sales/dashboardAnalytics',
    component: './pages/Analytics/DashboardAnalytics',
    permission: PERMISSIONS.ANALYTICS_MENU,
  },

  // DELIVERY
  {
    name: 'DISTRIBUZIONE',
    path: '/delivery',
    component: './pages/Plannings/PlanningsManager',
    permission: PERMISSIONS.PLANNING_MENU,
    routes: [
      { name: <><UnorderedListOutlined /> Pianificazioni</>, path: '/delivery/plannings', permission: PERMISSIONS.PLANNING_MENU, disabled: false },
      { name: <><NotificationOutlined /> Campagne </>, path: '/delivery/campaigns', permission: PERMISSIONS.CAMPAIGN_MENU, disabled: false },
      { name: <><VideoCameraOutlined /> Espletamento</>, path: 'https://appeso.alessipubblicita.it', disabled: false, permission: PERMISSIONS.PLANNING_MENU },
    ]
  },

  {
    path: '/delivery/plannings',
    component: './pages/Plannings/PlanningsManager',
    permission: PERMISSIONS.PLANNING_MENU,
  },
  {
    path: '/delivery/plannings/:id',
    component: './pages/Plannings/PlanningDetail',
    permission: PERMISSIONS.PLANNING_READ,
  },
  {
    path: '/delivery/plannings/:id/search',
    component: './pages/Plannings/PlanningDetail',
    permission: PERMISSIONS.PLANNING_READ,
  },

  {
    path: '/delivery/campaigns',
    component: './pages/Campaigns/CampaignsManager',
    permission: PERMISSIONS.CAMPAIGN_MENU,
  },
  {
    path: '/delivery/campaigns/:id',
    component: './pages/Campaigns/CampaignDetail',
    permission: PERMISSIONS.CAMPAIGN_READ,
  },

  {
    path: '/delivery/DOOHanalytics',
    component: './pages/Analytics/DOOHAnalytics',
    //permission: PERMISSIONS.ANALYTICS_ALL,
  },

  // MEDIA MONITOR
  {
    name: 'MEDIA MONITOR',
    path: '/media-monitor',
    component: './pages/MediaMonitor/MediaMonitor',
    routes: [
      { name: <><AuditOutlined /> Rilevazioni</>, path: '/media-monitor/monitor', disabled: false, permission: PERMISSIONS.DETECTION_MENU },
      { name: <><RiseOutlined /> Riepilogo</>, path: '/media-monitor/analytics', key: 'mediamonitor-analytics', disabled: false, permission: PERMISSIONS.DETECTION_MENU },
      {
        name: <><HighlightOutlined /> Gestione Campi</>, path: '/media-monitor/manage', disabled: false, permission: PERMISSIONS.DETECTION_MENU,
      },
    ],
    permission: PERMISSIONS.DETECTION_MENU,
  },
  {
    path: '/media-monitor/monitor',
    component: './pages/MediaMonitor/MediaMonitor',
    permission: PERMISSIONS.DETECTION_MENU,
  },
  {
    path: '/media-monitor/analytics',
    component: './pages/Analytics/MediaAnalytics',
    permission: PERMISSIONS.DETECTION_MENU,
  },
  {
    path: '/media-monitor/manage',
    component: './pages/MediaMonitor/MediaMonitorManageFields',
    permission: PERMISSIONS.DETECTION_AGENT_ALL,
  },

  // OTHER
  {
    path: '/dooh-manage/manage',
    component: './pages/DoohManager/DoohManager',
    permission: PERMISSIONS.DETECTION_MENU,
  },
  {
    path: '/shows-manage/manage',
    component: './pages/ShowsManager/ShowsManager',
    //permission: PERMISSIONS.SHOWS_ALL,
  },
  {
    path: '/dooh/players',
    component: './pages/Dooh/Players',
    //permission: PERMISSIONS.PLAYERS_ALL,
  },
  {
    path: '/playerDOOH',
    component: './pages/Shows/ShowManager',
    //permission: PERMISSIONS.SHOWS_ALL,
  },
  {
    path: '/settings/users',
    component: './pages/Settings/UsersSettings',
    permission: PERMISSIONS.USER_ALL,
  },
  {
    path: "/profile",
    component: "./pages/Profile/Profile.jsx",
    permission: PERMISSIONS.USER_READ,
  },
  {
    path: "/test",
    component: "./pages/Test.jsx",
    permission: PERMISSIONS.TEST_ALL,
  },
];